// Import model
import { Address } from '../models/Address';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Address - handles JSON serialization and deserialization with type validation
 */
export class AddressSerializer {
  /**
   * Deserializes a JSON string into a Address instance
   */
  static deserialize(json: string): Address {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Address instance
   */
  static fromObject(obj: any): Address {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Address');
    }


    const instance: Address = {
      address: obj['address'] as string | undefined,
      city: obj['city'] as string | undefined,
      country: obj['country'] as string | undefined,
      location: obj['location'] as any | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      state: obj['state'] as string | undefined,
      address2: obj['address2'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Address instances
   */
  static deserializeArray(json: string): Address[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Address instance to a JSON string
   */
  static serialize(instance: Address): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Address instance to a plain object
   */
  static toObject(instance: Address): any {
    return {
      'address': instance.address,
      'city': instance.city,
      'country': instance.country,
      'location': instance.location,
      'postalCode': instance.postalCode,
      'state': instance.state,
      'address2': instance.address2,
    };
  }

  /**
   * Serializes an array of Address instances to a JSON string
   */
  static serializeArray(instances: Address[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
